import { createRouter, createWebHistory, Router } from "vue-router";
import { RouteNames, routes } from "@/router/routes";
import { useCookies } from "@vueuse/integrations/useCookies";

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to) => {
  const { get } = useCookies();

  const token = get("token");

  if (!token && to.name !== "LoginView") {
    return { name: RouteNames.LOGIN_VIEW };
  }

  return true;
});

export default router;
